/**
 * Choose which media device to use: keep the saved one if it's still plugged in,
 * otherwise default to the first available, otherwise none. Pure → testable
 * without `navigator.mediaDevices`.
 */
export function pickDevice(
  devices: Array<{ deviceId: string }>,
  preferredId: string | undefined,
): string | undefined {
  if (preferredId && devices.some((d) => d.deviceId === preferredId)) return preferredId;
  return devices[0]?.deviceId;
}
